import React from 'react';
import { Link } from 'react-router-dom';

const Nav = () => {
    return (
        <ul className="mainmenu">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us-1">About</Link></li>
            <li><Link to="/course-1">Programs</Link></li>
            <li><Link to="/blog-grid-1">News</Link></li>
            <li><Link to="/contact-us">Contact</Link></li>
        </ul>
    )
}
export default Nav;
